<script>
import Router from '@/router/index.js'
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import TeamCard from './TeamCard'
import { getMembersByTeamId, getTeamByTeamId, removeTeam, changeTeamName, addExternalMenmberToTeam, hasInvitedMemberInTeam } from '@/api/FirebaseTeamWrapper.js'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { hasAdminRole } from '@/api/Utilities.js'

const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')

function countLength (array, keyword) {
  let length = 0
  for (const user of array) {
    if (user.role === keyword) {
      length++
    }
  }
  return length
}

export default {
  components: {TeamCard, modalWindow},
  data () {
    return {
      myUserId: '',
      myUserData: undefined,
      myTeamRole: '',
      selectedTeamId: '',
      teamName: '',
      newTeamName: '',
      alertTeamNameMsg: '',
      members: [],
      memberLength: 0,
      ownerLength: 0,
      isCreated: false,
      deletedMemberMsg: '',
      enableDeleteUser: false,
      confirmDeleteMsg: '',
      deletedTeamId: '',
      isDeleted: false,
      deleteTeamErrorMsg: '',
      email: '',
      alertExternalMsg: '',
      enableExternalUserWindow: false,
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    await this.init()
    document.title = 'EditProfile | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'EditTeam | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.myUserId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'editteam/EditTeam')
    }
    this.isCreated = true
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  watch: {
    async $route (to, from) {
      // ルートの変更の検知...user/:A to user/:Bの際に画面描画されないため
      if (from.path !== to.path) {
        // treeの再取得
        await this.init()
      }
    },
    alertTeamNameMsg: function () {
      if (this.alertTeamNameMsg.length > 0) {
        setTimeout(() => { this.alertTeamNameMsg = '' },
          1000)
      }
    },
    deletedMemberMsg: function () {
      if (this.deletedMemberMsg.length > 0) {
        setTimeout(() => { this.deletedMemberMsg = '' },
          1000)
      }
    },
    alertExternalMsg: function () {
      if (this.alertExternalMsg.length > 0) {
        setTimeout(() => { this.alertExternalMsg = '' },
          1000)
      }
    }
  },
  methods: {
    async init () {
      this.isDeleted = false
      this.myUserId = await getMyUserId()
      this.selectedTeamId = this.$route.params.teamId
      const team = await getTeamByTeamId(this.selectedTeamId)
      this.teamName = team.teamName
      this.newTeamName = this.teamName
      this.members = await getMembersByTeamId(this.selectedTeamId)
      this.ownerLength = countLength(this.members, 'owner')
      this.memberLength = this.members.length
      this.deletedMemberMsg = ''
      // 自分のチームロールの代入
      const targetIndex = this.members.findIndex(({userId}) => userId === this.myUserId)
      if (targetIndex !== -1) {
        this.myTeamRole = this.members[targetIndex].role
      } else {
        this.myTeamRole = ''
      }
      this.members.splice()
    },
    deleteTeam () {
      this.confirmDeleteMsg = 'チームを削除しますか？'
      this.enableDeleteUser = true
    },
    cancelDelete () {
      this.enableDeleteUser = false
      this.confirmDeleteMsg = ''
      this.deleteTeamErrorMsg = ''
    },
    async doDelete () {
      const user = await getMyUserData(this.myUserId)
      if (user.teams.length <= 1) {
        this.deleteTeamErrorMsg = '最後のteamは削除できせん'
        return
      }
      try {
        await removeTeam(this.selectedTeamId)
        this.confirmDeleteMsg = ''
        this.enableDeleteUser = false
        this.isDeletedTeamId = this.selectedTeamId
        this.isDeleted = true
        Router.push('/myteams')
      } catch (err) {
        this.confirmDeleteMsg = ''
        this.enableDeleteUser = false
      }
    },
    async deleteMember () {
      this.members = await getMembersByTeamId(this.selectedTeamId)
      this.ownerLength = countLength(this.members, 'owner')
      this.memberLength = this.members.length
      this.deletedMemberMsg = 'メンバーを削除しました'
    },
    async updateRole () {
      this.members = await getMembersByTeamId(this.selectedTeamId)
      this.ownerLength = countLength(this.members, 'owner')
    },
    async updateTeamName () {
      this.alertTeamNameMsg = ''
      const teamName = this.newTeamName
      if (!teamName) {
        this.alertTeamNameMsg = '文字を入力してください'
        return
      }
      if (teamName.length > 20) {
        this.alertTeamNameMsg = '20文字を超えてます'
        return
      }
      if (teamName === this.teamName) {
        this.alertTeamNameMsg = '名前が同じです'
        return
      }
      try {
        await changeTeamName(this.selectedTeamId, teamName)
        this.alertTeamNameMsg = '変更に成功しました'
        this.teamName = teamName
      } catch (err) {
        this.alertTeamNameMsg = 'failed'
        this.newTeamName = this.teamName
        console.log(err)
      }
    },
    cancelTeamName () {
      this.newTeamName = this.teamName
      this.alertTeamNameMsg = ''
    },
    async addExternalUser () {
      this.alertExternalMsg = ''
      console.log(this.email)
      if (!this.email) {
        this.alertExternalMsg = 'メールアドレスを入力してください'
        return
      }
      if (!this.email.includes('@')) {
        this.alertExternalMsg = 'メールアドレスを入力してください'
        return
      }

      // メアドの小文字化
      this.email = this.email.toLowerCase()

      const hasInvitation = await hasInvitedMemberInTeam(this.selectedTeamId, this.email)
      if (hasInvitation) {
        this.enableExternalUserWindow = true
        return
      }

      try {
        await addExternalMenmberToTeam(this.selectedTeamId, this.teamName, this.email, '', this.myUserId, false)
        this.email = ''
        this.alertExternalMsg = '招待メールをお送りしました'
      } catch (err) {
        console.log(err)
        this.alertExternalMsg = '失敗しました'
      }
    },
    cancelAddExternalUser () {
      this.enableExternalUserWindow = false
    },
    async doAddExternalUser () {
      this.enableExternalUserWindow = false
      this.alertExternalMsg = ''
      try {
        await addExternalMenmberToTeam(this.selectedTeamId, this.teamName, this.email, '', this.myUserId, true)
        this.email = ''
        this.alertExternalMsg = '招待メールを再送しました'
      } catch (err) {
        this.alertExternalMsg = '失敗しました'
      }
    }
  }
}
</script>
<style scoped>
.edit-team {
  max-width: 768px;
  margin: auto;
  padding: 1.0rem;
}
.team-edit .field {
  margin-bottom: 0.0rem;
}
.toast {
  margin-top: 0.5rem;
  background-color: #f14668;
  padding: 0.2rem 0.8rem;
  border-radius: 0.5rem;
  position: absolute;
  width: max-content;
  z-index: 5;
}
.q-bar .columns .column .progress{
  margin-top: 2px;
}
.is-size-8 {
  font-size: 0.55rem !important;
}
.role {
  padding-bottom: 0.45rem;
}
.delete-role {
  margin-right: 1.6rem;
}
.line {
 background-color: #f5f5f5;
 border: none;
 display: block;
 height: 2px;
 margin: 0.8rem 0;
}
</style>
<template>
<div class='edit-team' v-if="isCreated">
  <br>
  <!-- チーム名の変更-->
  <div class="team-name" v-if="myTeamRole === 'owner'">
    <div class="team-edit">
      <label class="label has-text-left is-size-7">チーム名</label>
      <div class="field is-grouped">
        <p class="control is-expanded">
          <input class="input is-size-7 has-text-weight-bold" type="text" placeholder="チーム名" v-model="newTeamName">
        </p>
        <div class="control">
          <a class="button is-link is-small" @click="updateTeamName()">
            更新
          </a>
          <div class="toast has-text-white is-size-8" v-if="alertTeamNameMsg">{{alertTeamNameMsg}}</div>
        </div>
        <div class="control">
          <a class="button is-light is-small" @click="cancelTeamName()">
            キャンセル
          </a>
        </div>
      </div>
      <div class="q-bar">
        <div class="columns is-mobile is-marginless">
          <div class="column is-three-quarters">
            <div class="add-paddingleft">
              <progress class="progress is-gray is-small" :value="newTeamName.length" max="20"></progress>
            </div>
          </div>
          <div class="column is-size-7">残り{{20-newTeamName.length}}</div>
        </div>
      </div>
    </div>
    <div class="line"></div>
  </div>
  <div class="team-info" v-if="!isDeleted">
    <!-- チームメンバーの表示 -->
    <div class="teams">
      <label class="label has-text-left is-size-7">既存メンバー</label>
      <div class="columns is-multiline is-mobile is-marginless">
        <div class="column is-half role">
          <div class="control is-size-8 has-text-left has-text-weight-bold">
            名前
          </div>
        </div>
        <div class="column one-quoter role">
          <div class="control is-size-8 has-text-right has-text-weight-bold">
            役割
          </div>
          <div class="toast has-text-white is-size-8" v-if="deletedMemberMsg">{{deletedMemberMsg}}</div>
        </div>
        <div class="column role">
          <div class="control delete-role is-size-8 has-text-right has-text-weight-bold">
            削除
          </div>
        </div>
      </div>
      <TeamCard
        v-for="(memberData, index) in members"
        :memberData = "memberData"
        :myUserId = "myUserId"
        :myTeamRole = "myTeamRole"
        :teamId = "selectedTeamId"
        :memberLength = "memberLength"
        :ownerLength = "ownerLength"
        :key = "index"
        @deleteMember = "deleteMember"
        @updateRole = "updateRole"
      />
    </div>
    <br>
    <!-- 外部メンバーの追加-->
    <div class="add-external-member" v-if="myTeamRole === 'owner'">
      <label class="label has-text-left is-size-7">外部メンバーをEmailで招待する</label>
      <div class="field is-grouped">
        <p class="control is-expanded has-icons-left is-size-7 ">
          <input class="input is-size-7 has-text-weight-bold" type="text" placeholder="Email" v-model="email">
          <span class="icon is-small is-left">
            <i class="fa-regular fa-envelope"></i>
          </span>
        </p>
        <div class="control">
          <a class="button is-small is-link" @click="addExternalUser()">
            追加
          </a>
        </div>
        <div class="toast has-text-white is-size-8" v-if="alertExternalMsg">{{alertExternalMsg}}</div>
      </div>
    </div>
    <div class="add-external-modal-window">
      <modalWindow @close="cancelAddExternalUser()" v-if="enableExternalUserWindow">
        <template slot="header">
          <div class="buttons is-right">
            <button class="delete" @click="cancelAddExternalUser()"></button>
          </div>
        </template>
        <p>既に一度招待メールを送っています。再送しますか？</p>
        <template slot="footer">
          <div class="buttons is-centered">
            <button class="button" @click="cancelAddExternalUser()">キャンセル</button>
            &nbsp;
            &nbsp;
            &nbsp;
            <button class="button is-link" @click="doAddExternalUser()">はい</button>
          </div>
        </template>
      </modalWindow>
    </div>
    <hr>
    <!-- チームの削除-->
    <div class="trash" v-if="myTeamRole === 'owner'">
      <div class="field">
        <label class="label has-text-left is-size-7">チームの削除</label>
        <div class="buttons has-addons">
          <button class="button is-small is-danger" @click="deleteTeam()">
            <span>削除</span>
            <span class="icon is-small">
              <i class="fa-solid fa-times"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="Delete-modal-window">
      <modalWindow @close="cancelDelete()" v-if="enableDeleteUser">
        <template slot="header">
          <div class="buttons is-right">
            <button class="delete" @click="cancelDelete()"></button>
          </div>
        </template>
        <p>{{confirmDeleteMsg}}</p>
        <br>
        <p class="text is-size-8 has-text-danger">{{this.deleteTeamErrorMsg}}</p>
        <template slot="footer">
          <div class="buttons is-centered">
            <button class="button" @click="cancelDelete()">キャンセル</button>
            &nbsp;
            &nbsp;
            &nbsp;
            <button class="button is-link" @click="doDelete()">削除</button>
          </div>
        </template>
      </modalWindow>
    </div>
  </div>
  <!--
    <pre>{{$data}}</pre>
  -->
</div>
</template>



// WEBPACK FOOTER //
// src/pages/editteam/EditTeam.vue